import './styles.css';
import usePassengerInformationForm from "../../../viewModels/flights/passenger.information.form.viewModel";
import ActivityIndicator from '../../share/components/activityIndicator';
import SvgIcon, { iconList } from '../../share/components/iconSVG';
import ModalContainer from '../../share/components/modalContainer';
import RequiredSession from '../../share/components/requiredSession';
import Step1 from './components/step1';
import Step2 from './components/step2';
import Step3 from './components/step3';
import TabletPassengers from './components/tabletPassengers';
import TabletItinerary from './components/tabletItinerary';

function PassengerInformationForm() {
  const {
    step,
    setStep,
    loadingScreen,
    userDetail,
    userToken,
    needLogin,
    stepsList,
    hiddenModalSesion,
    goToScreen,
    savePNR,
    isLoading,
    showModal,
    message,
    location,
    setShowModalClick,

    controlNumberPNR,
    globalPNR,
    setGlobalPNR,
    dataSavePNR,
    showListPassenger,
    modalListPassenger,
    getDataToEdit,
    dataToEdit,
    setModalListPassenger
  } = usePassengerInformationForm();

  return (
    <div className="pifs">
      <ModalContainer
        show={modalListPassenger}
        hidden={() => { }}
        sizeWidth={60}
        sizeHeight={90}
        hiddenButton={true}
      >
        <div className='TabletPassengersContainer'>
          <TabletPassengers
            list={dataSavePNR?.travellers}
            toEdit={getDataToEdit}
            editing={true}
            title={'Verificación de datos de pasajeros'}
          />
          <TabletItinerary
            list={dataSavePNR?.itinerary}
            toEdit={getDataToEdit}
            editing={true}
            title={'Verificación de Itinerario'}
          />
          <div className='TabletPassengersContainerBtnContainer'>
            <div className='TabletPassengersContainerBtnClocet' onClick={() => setModalListPassenger(false)}>
              <p className='TabletPassengersContainerBtnText'>
                Cerrar
              </p>
            </div>
            <div className='TabletPassengersContainerBtn' onClick={() => savePNR()}>
              <p className='TabletPassengersContainerBtnText'>
                Aceptar
              </p>
            </div>
          </div>
        </div>
      </ModalContainer>

      <ModalContainer
        show={needLogin}
        hidden={hiddenModalSesion}
        sizeWidth={60}
        sizeHeight={50}
      >
        <RequiredSession navigation={goToScreen} />
      </ModalContainer>

      <ModalContainer
        show={showModal}
        hidden={setShowModalClick}
        sizeWidth={40}
        sizeHeight={50}
      >
        {isLoading ?
          <ActivityIndicator
            colorFill='#104172'
            size={60}
          /> :
          <div className='pifsModal'>
            {message && message?.code === "ERROR"
              ? <SvgIcon color={'red'} name={iconList?.IconCloseCircleOutLine} size={120} />
              : <SvgIcon color={'green'} name={iconList?.IconCheckSucces} size={120} />
            }
            <p className='pifsModalText'>{message?.text}</p>
            <p className='pifsModalCode'>{message?.code}</p>
            {message?.code !== 'ERROR' &&
              <p className='pifsModalText'>Hemos enviado la información a su correo electrónico</p>
            }
            <div className='pifsModalBtn' onClick={() => setShowModalClick(false)}>
              <p className='pifsModalBtnText'>Aceptar</p>
            </div>
          </div>

        }
      </ModalContainer>

      <div className='pifsStepsList'>
        {stepsList.map((index, key) => {
          const isActive = index.id === step
          return (
            <div key={key}
              onClick={() => index.available && setStep(key)}
              className={`pifsStep ${isActive ? 'pifsStepOn' : 'pifsStepOff'}`}>
              <p className={`pifsStepText ${isActive ? 'pifsStepTextOn' : 'pifsStepTextOff'}`}>
                {index.name}
              </p>
            </div>
          )
        })
        }
      </div>
      {loadingScreen ?
        <div className='loadingScreen'>
          <ActivityIndicator
            colorFill='#104172'
            size={60}
          />
        </div>
        :
        <>
          {step === 1 &&
            <Step1
              savePNR={showListPassenger}
              userDetail={userDetail}
              location={location}
              dataToEdit={dataToEdit}
            />
          }
          {step === 2 &&
            <Step2
              setStep={setStep}
              controlNumberPNR={controlNumberPNR}
              setGlobalPNR={setGlobalPNR}
              dataSavePNR={dataSavePNR}
            />
          }
          {step === 3 &&
            <Step3
              userDetail={userDetail}
              userToken={userToken}
              location={location}
              PNR={globalPNR}
              dataSavePNR={dataSavePNR}
            />
          }
        </>
      }
    </div>
  )
}

export default PassengerInformationForm;
